module.exports = __webpack_public_path__ + "static/media/socialiaa-overview.c7ef543b.gif";